import type { initErase } from './erase-canvas';
import { makeAutoObservable } from 'mobx';

export const ZoomConfig = {
  /** 最大缩放倍数 */
  MAX: 3,
  /** 最小缩放倍数 */
  MIN: 0.1,
  /** 缩放增加倍数 */
  STEP: 0.1,
  /** 留白 */
  SPACE: 26,
};
export const basicEraseForm = {
  brushType: '涂抹',
  brushSize: 24,
  width: 0,
  height: 0,
  refer_img: '',
};

export const basicEraseConfig = {
  bg: 'transparent',
    color: 'rgba(0, 106, 255, 0.5)',
    gradientColor: 'rgba(255, 255, 255, 0.5)', // 修改渐变色第二个颜色
    useGradient: true, // 是否使用渐变色
    gradientType: 'linear', // 渐变类型：linear或radial
    gradientDirection: 'to right', // 线性渐变方向
    draw: 24,
    hideCursor: true,
    shape: 'rect',
    bgType: '',
}

class Store {
  constructor() {
    makeAutoObservable(this);
  }
  eraseForm = {
    ...basicEraseForm
  };
  eraseConfig = {
  ...basicEraseConfig
  };
  zoomConfig = {
    left: 0,
    top: 0,
    width: 0,
    height: 0,
    scaleType: 1,
  };
  eraseDoodle: ReturnType<typeof initErase> | undefined;
  loading = false;
  result: null | any = null;
  setLoading = (data: boolean) => {
    this.loading = data;
  };
  setZoomConfig = data => {
    this.zoomConfig = { ...this.zoomConfig, ...data };
  };
  setResult = data => {
    this.result = data;
  };
  setEraseForm = (data: Partial<typeof this.eraseForm>) => {
    this.eraseForm = { ...this.eraseForm, ...data };
  };
  setEraseConfig = (data: Partial<typeof this.eraseConfig>) => {
    this.eraseConfig = { ...this.eraseConfig, ...data };
  };
  setEraseDoodle = (data: ReturnType<typeof initErase> | undefined) => {
    this.eraseDoodle = data;
  };
}

// 确保导出的是实例而不是类
export const EraseCanvasStore = new Store();
